<template>
  <div id="project-setting-w">
    <div class="head">
      <div class="section-title">Project Setting</div>
      <div class="project-buttons">
        <i class="project-button material-icons" @click="$emit('close')" >exit_to_app</i>
      </div>
    </div>
    <div class="offline-warning" v-if="!onLine">Read-only mode, since you are offline.</div>

    <div class="setting-w">
    <!-- Project Status -->
    <div class="settings">
      <div class="setting-title">
        <div>Project Status</div>
        <!-- <i class="material-icons" v-show="onLine && !editingTarget" @click="startEdit('name')">create</i> -->
      </div>
      <div class="status-buttons-w">
        <div @click="changeProjectStatus('MEASUREMENT')" :class="project.status === 'MEASUREMENT' ? 'status-button measurement current' : 'status-button measurement'">Measurement</div>
        <div @click="changeProjectStatus('MANUFACTURE')" :class="project.status === 'MANUFACTURE' ? 'status-button manufacture current' : 'status-button manufacture'">Manufacture</div>
        <div @click="changeProjectStatus('INSTALLATION')" :class="project.status === 'INSTALLATION' ? 'status-button installation current' : 'status-button installation'">Installation</div>
        <div @click="changeProjectStatus('DONE')" :class="project.status === 'DONE' ? 'status-button done current' : 'status-button done'">Finish</div>
      </div>
    </div>

    <!-- Project Name -->
    <div class="settings">
      <div class="setting-title">
        <div>Project Name</div>
        <!-- <i class="material-icons" v-show="onLine && !editingTarget" @click="startEdit('name')">create</i> -->
        <div v-if="canEidt" class="detail-button" style="color: #409eff" v-show="onLine && !editingTarget" @click="startEdit('name')">Edit</div>
      </div>
      <div class="setting-value" v-if="editingTarget !== 'name'">{{project.name || 'No project name'}}</div>
      <el-input v-else v-model="inputData" v-on:keyup.enter="exitEdit(true)">
        <el-button slot="append"><i class="material-icons" style="color: #1e88e5;" @click="exitEdit(true)">{{savingChange ? 'cloud_upload' : 'check'}}</i></el-button>
        <el-button slot="append"><i class="material-icons" @click="exitEdit(false)">close</i></el-button>
      </el-input>
    </div>

    <!-- Ship To -->
    <div class="settings">
      <div class="setting-title">
        <div>Ship To</div>
        <!-- <i class="material-icons" v-show="onLine && !editingTarget" @click="startEdit('shipTo')">create</i> -->
        <div v-if="canEidt" class="detail-button" style="color: #409eff" v-show="onLine && !editingTarget" @click="startEdit('shipTo')">Edit</div>
      </div>
      <div class="setting-value" v-if="editingTarget !== 'shipTo'">{{project.shipTo || 'No ship to'}}</div>
      <el-input v-else v-model="inputData" v-on:keyup.enter="exitEdit(true)">
        <el-button slot="append"><i class="material-icons" style="color: #1e88e5;" @click="exitEdit(true)">{{savingChange ? 'cloud_upload' : 'check'}}</i></el-button>
        <el-button slot="append"><i class="material-icons" @click="exitEdit(false)">close</i></el-button>
      </el-input>
    </div>

    <!-- Company Name -->
    <div class="settings">
      <div class="setting-title">
        <div>Company Name</div>
        <!-- <i class="material-icons" v-show="onLine && !editingTarget" @click="startEdit('companyName')">create</i> -->
        <div v-if="canEidt" class="detail-button" style="color: #409eff" v-show="onLine && !editingTarget" @click="startEdit('companyName')">Edit</div>
      </div>
      <div class="setting-value" v-if="editingTarget !== 'companyName'">{{project.companyName || 'No company name'}}</div>
      <el-input v-else v-model="inputData" v-on:keyup.enter="exitEdit(true)">
        <el-button slot="append"><i class="material-icons" style="color: #1e88e5;" @click="exitEdit(true)">{{savingChange ? 'cloud_upload' : 'check'}}</i></el-button>
        <el-button slot="append"><i class="material-icons" @click="exitEdit(false)">close</i></el-button>
      </el-input>
    </div>

    <!-- Contact -->
    <div class="settings">
      <div class="setting-title">
        <div>Contact</div>
        <!-- <i class="material-icons" v-show="onLine && !editingTarget" @click="startEdit('contact')">create</i> -->
        <div v-if="canEidt" class="detail-button" style="color: #409eff" v-show="onLine && !editingTarget" @click="startEdit('contact')">Edit</div>
      </div>
      <div class="setting-value" v-if="editingTarget !== 'contact'">{{project.contact || 'No contact'}}</div>
      <el-input v-else v-model="inputData" v-on:keyup.enter="exitEdit(true)">
        <el-button slot="append"><i class="material-icons" style="color: #1e88e5;" @click="exitEdit(true)">{{savingChange ? 'cloud_upload' : 'check'}}</i></el-button>
        <el-button slot="append"><i class="material-icons" @click="exitEdit(false)">close</i></el-button>
      </el-input>
    </div>

    <!-- Street -->
    <div class="settings">
      <div class="setting-title">
        <div>Street</div>
        <!-- <i class="material-icons" v-show="onLine && !editingTarget" @click="startEdit('street')">create</i> -->
        <div v-if="canEidt" class="detail-button" style="color: #409eff" v-show="onLine && !editingTarget" @click="startEdit('street')">Edit</div>
      </div>
      <div class="setting-value" v-if="editingTarget !== 'street'">{{project.street || 'No street'}}</div>
      <el-input v-else v-model="inputData" v-on:keyup.enter="exitEdit(true)">
        <el-button slot="append"><i class="material-icons" style="color: #1e88e5;" @click="exitEdit(true)">{{savingChange ? 'cloud_upload' : 'check'}}</i></el-button>
        <el-button slot="append"><i class="material-icons" @click="exitEdit(false)">close</i></el-button>
      </el-input>
    </div>

    <!-- City -->
    <div class="settings">
      <div class="setting-title">
        <div>City</div>
        <!-- <i class="material-icons" v-show="onLine && !editingTarget" @click="startEdit('city')">create</i> -->
        <div v-if="canEidt" class="detail-button" style="color: #409eff" v-show="onLine && !editingTarget" @click="startEdit('city')">Edit</div>
      </div>
      <div class="setting-value" v-if="editingTarget !== 'city'">{{project.city || 'No city'}}</div>
      <el-input v-else v-model="inputData" v-on:keyup.enter="exitEdit(true)">
        <el-button slot="append"><i class="material-icons" style="color: #1e88e5;" @click="exitEdit(true)">{{savingChange ? 'cloud_upload' : 'check'}}</i></el-button>
        <el-button slot="append"><i class="material-icons" @click="exitEdit(false)">close</i></el-button>
      </el-input>
    </div>

    <!-- State -->
    <div class="settings">
      <div class="setting-title">
        <div>State</div>
        <!-- <i class="material-icons" v-show="onLine && !editingTarget" @click="startEdit('state')">create</i> -->
        <div v-if="canEidt" class="detail-button" style="color: #409eff" v-show="onLine && !editingTarget" @click="startEdit('state')">Edit</div>
      </div>
      <div class="setting-value" v-if="editingTarget !== 'state'">{{project.state || 'No state'}}</div>
      <el-input v-else v-model="inputData" v-on:keyup.enter="exitEdit(true)">
        <el-button slot="append"><i class="material-icons" style="color: #1e88e5;" @click="exitEdit(true)">{{savingChange ? 'cloud_upload' : 'check'}}</i></el-button>
        <el-button slot="append"><i class="material-icons" @click="exitEdit(false)">close</i></el-button>
      </el-input>
    </div>

     <!-- Phone -->
    <div class="settings">
      <div class="setting-title">
        <div>Phone</div>
        <!-- <i class="material-icons" v-show="onLine && !editingTarget" @click="startEdit('phone')">create</i> -->
        <div v-if="canEidt" class="detail-button" style="color: #409eff" v-show="onLine && !editingTarget" @click="startEdit('phone')">Edit</div>
      </div>
      <div class="setting-value" v-if="editingTarget !== 'phone'">{{project.phone || 'No phone'}}</div>
      <el-input v-else v-model="inputData" v-on:keyup.enter="exitEdit(true)">
        <el-button slot="append"><i class="material-icons" style="color: #1e88e5;" @click="exitEdit(true)">{{savingChange ? 'cloud_upload' : 'check'}}</i></el-button>
        <el-button slot="append"><i class="material-icons" @click="exitEdit(false)">close</i></el-button>
      </el-input>
    </div>

     <!-- ZIP -->
    <div class="settings">
      <div class="setting-title">
        <div>Zip</div>
        <!-- <i class="material-icons" v-show="onLine && !editingTarget" @click="startEdit('zip')">create</i> -->
        <div v-if="canEidt" class="detail-button" style="color: #409eff" v-show="onLine && !editingTarget" @click="startEdit('zip')">Edit</div>
      </div>
      <div class="setting-value" v-if="editingTarget !== 'zip'">{{project.zip || 'No ZIP'}}</div>
      <el-input v-else v-model="inputData" v-on:keyup.enter="exitEdit(true)">
        <el-button slot="append"><i class="material-icons" style="color: #1e88e5;" @click="exitEdit(true)">{{savingChange ? 'cloud_upload' : 'check'}}</i></el-button>
        <el-button slot="append"><i class="material-icons" @click="exitEdit(false)">close</i></el-button>
      </el-input>
    </div>

     <!-- Ship Via -->
    <div class="settings">
      <div class="setting-title">
        <div>Ship Via</div>
        <!-- <i class="material-icons" v-show="onLine && !editingTarget" @click="startEdit('shipVia')">create</i> -->
        <div v-if="canEidt" class="detail-button" style="color: #409eff" v-show="onLine && !editingTarget" @click="startEdit('shipVia')">Edit</div>
      </div>
      <div class="setting-value" v-if="editingTarget !== 'shipVia'">{{project.shipVia || 'No ship info'}}</div>
      <el-input v-else v-model="inputData" v-on:keyup.enter="exitEdit(true)">
        <el-button slot="append"><i class="material-icons" style="color: #1e88e5;" @click="exitEdit(true)">{{savingChange ? 'cloud_upload' : 'check'}}</i></el-button>
        <el-button slot="append"><i class="material-icons" @click="exitEdit(false)">close</i></el-button>
      </el-input>
    </div>

    <!-- Handling Fee -->
    <div class="settings">
      <div class="setting-title">
        <div>Handling Fee</div>
        <!-- <i class="material-icons" v-show="onLine && !editingTarget" @click="startEdit('shipVia')">create</i> -->
        <div v-if="canEidt" class="detail-button" style="color: #409eff" v-show="onLine && !editingTarget" @click="startEdit('handlingFee')">Edit</div>
      </div>
      <div class="setting-value" v-if="editingTarget !== 'handlingFee'">{{project.handlingFee || '0'}}</div>
      <el-input v-else v-model="inputData" v-on:keyup.enter="exitEdit(true)">
        <el-button slot="append"><i class="material-icons" style="color: #1e88e5;" @click="exitEdit(true)">{{savingChange ? 'cloud_upload' : 'check'}}</i></el-button>
        <el-button slot="append"><i class="material-icons" @click="exitEdit(false)">close</i></el-button>
      </el-input>
    </div>

    <!-- Purchase Order -->
    <div class="settings">
      <div class="setting-title">
        <div>Purchase Order</div>
        <!-- <i class="material-icons" v-show="onLine && !editingTarget" @click="startEdit('purchaseOrder')">create</i> -->
        <div v-if="canEidt" class="detail-button" style="color: #409eff" v-show="onLine && !editingTarget" @click="startEdit('purchaseOrder')">Edit</div>
      </div>
      <div class="setting-value" v-if="editingTarget !== 'purchaseOrder'">{{project.purchaseOrder || 'No purchase order'}}</div>
      <el-input v-else v-model="inputData" v-on:keyup.enter="exitEdit(true)">
        <el-button slot="append"><i class="material-icons" style="color: #1e88e5;" @click="exitEdit(true)">{{savingChange ? 'cloud_upload' : 'check'}}</i></el-button>
        <el-button slot="append"><i class="material-icons" @click="exitEdit(false)">close</i></el-button>
      </el-input>
    </div>

    <!-- Side Mark -->
    <div class="settings">
      <div class="setting-title">
        <div>Side Mark</div>
        <!-- <i class="material-icons" v-show="onLine && !editingTarget" @click="startEdit('sideMark')">create</i> -->
        <div v-if="canEidt" class="detail-button" style="color: #409eff" v-show="onLine && !editingTarget" @click="startEdit('sideMark')">Edit</div>
      </div>
      <div class="setting-value" v-if="editingTarget !== 'sideMark'">{{project.sideMark || 'No side mark'}}</div>
      <el-input v-else v-model="inputData" v-on:keyup.enter="exitEdit(true)">
        <el-button slot="append"><i class="material-icons" style="color: #1e88e5;" @click="exitEdit(true)">{{savingChange ? 'cloud_upload' : 'check'}}</i></el-button>
        <el-button slot="append"><i class="material-icons" @click="exitEdit(false)">close</i></el-button>
      </el-input>
    </div>

    <!-- Work Order -->
    <div class="settings">
      <div class="setting-title">
        <div>Work Order</div>
        <!-- <i class="material-icons" v-show="onLine && !editingTarget" @click="startEdit('workOrder')">create</i> -->
        <div v-if="canEidt" class="detail-button" style="color: #409eff" v-show="onLine && !editingTarget" @click="startEdit('workOrder')">Edit</div>
      </div>
      <div class="setting-value" v-if="editingTarget !== 'workOrder'">{{project.workOrder || 'No work order'}}</div>
      <el-input v-else v-model="inputData" v-on:keyup.enter="exitEdit(true)">
        <el-button slot="append"><i class="material-icons" style="color: #1e88e5;" @click="exitEdit(true)">{{savingChange ? 'cloud_upload' : 'check'}}</i></el-button>
        <el-button slot="append"><i class="material-icons" @click="exitEdit(false)">close</i></el-button>
      </el-input>
    </div>

    <!-- QN -->
    <div class="settings">
      <div class="setting-title">
        <div>QN</div>
        <!-- <i class="material-icons" v-show="onLine && !editingTarget" @click="startEdit('qn')">create</i> -->
        <div v-if="canEidt" class="detail-button" style="color: #409eff" v-show="onLine && !editingTarget" @click="startEdit('qn')">Edit</div>
      </div>
      <div class="setting-value" v-if="editingTarget !== 'qn'">{{project.qn || 'No QN'}}</div>
      <el-input v-else v-model="inputData" v-on:keyup.enter="exitEdit(true)">
        <el-button slot="append"><i class="material-icons" style="color: #1e88e5;" @click="exitEdit(true)">{{savingChange ? 'cloud_upload' : 'check'}}</i></el-button>
        <el-button slot="append"><i class="material-icons" @click="exitEdit(false)">close</i></el-button>
      </el-input>
    </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'ProjectSetting',
  props: {
    project: Object
  },
  data () {
    return {
      editingTarget: null,
      inputData: '',
      savingChange: false
    }
  },
  computed: {
    onLine: function () {
      return this.$store.getters.onLine
    },
    canEidt: function () {
      // eslint-disable-next-line no-mixed-operators
      return this.$store.getters.currentUserInfo && this.$store.getters.currentUserInfo.permits.PROJECT_EDIT || false
    }
  },
  methods: {
    changeProjectStatus: async function (status) {
      if (!this.canEidt) {
        this.$message({
          showClose: true,
          message: 'Pemission needed to change the setting of project',
          type: 'error'
        })
        return
      }
      let project = this.project
      project.status = status
      let saveResult = await this.$store.dispatch('changeProjectSetting', project)
      if (saveResult.success) {
        this.$message({
          showClose: true,
          message: 'Status changed',
          type: 'success'
        })
      } else {
        this.$message({
          showClose: true,
          message: saveResult.error,
          type: 'error'
        })
      }
    },
    startEdit: function (target) {
      this.editingTarget = target
      this.inputData = this.project[target] || ''
    },
    exitEdit: async function (save) {
      if (save) {
        this.savingChange = true
        let project = this.project
        if (!this.inputData) {
          this.$message({
            showClose: true,
            message: 'Blank setting not saved',
            type: 'warning'
          })
          this.savingChange = false
          this.editingTarget = null
          this.inputData = ''
          return
        }
        project[this.editingTarget] = this.inputData
        let saveResult = await this.$store.dispatch('changeProjectSetting', project)
        if (saveResult.success) {
          this.$message({
            showClose: true,
            message: 'Saved',
            type: 'success'
          })
        } else {
          this.$message({
            showClose: true,
            message: saveResult.error,
            type: 'error'
          })
        }
      }
      this.savingChange = false
      this.editingTarget = null
      this.inputData = ''
    }
  }
}
</script>

<style scoped>

.project-buttons {
  text-align: right;
  /* margin-top: 24px; */
}

.project-button {
  font-size: 24px;
  margin-right: 24px;
  cursor: pointer;
  color: #1e88e5;
  cursor: pointer;
}

.head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 48px;
  margin: 0 12%;
}

.setting-w {
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 0 12%;
  width: 100%;
  margin-bottom: 80px;
}

.offline-warning {
  margin: 0 12% 12px 12%;
  box-sizing: border-box;
  padding: 4px 16px;
  border-radius: 10px;
  width: 76vw;
  font-size: 15px;
  line-height: 30px;
  background-color: rgba(0,0,0,0.12);
}

.settings {
  width: calc(50% - 16px);
  margin: 8px 8px;
  border: solid 1px #f0f0f0;
  border-radius: 15px;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 20px;
}

.setting-title {
  font-size: 15px;
  line-height: 22px;
  font-weight: normal;
  color: #969696;
  margin-bottom: 6px;
  display:flex;
  justify-content: space-between;
  align-items: center
}

.setting-value {
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
  color: #333;
}

.status-buttons-w {
  display: flex;
  flex-wrap: wrap;
}

.status-button {
  cursor: pointer;
  border-radius: 15px;
  text-align: center;
  width: 150px;
  margin-top: 6px;
  margin-right: 12px;
  box-sizing: border-box;
  padding: 5px 0 5px 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.measurement {
  box-shadow: inset 0 0 0 1px #3498db;
  -moz-box-shadow: inset 0 0 0 1px #3498db;
  -webkit-box-shadow: inset 0 0 0 1px #3498db;
  background-color: rgba(52, 152, 219, 0.3);
  color: #3498db;
}
.measurement.current {
  background-color: #3498db;
  color: white;
  font-weight: bold;
}

.manufacture {
  box-shadow: inset 0 0 0 1px #e67e22;
  -moz-box-shadow: inset 0 0 0 1px #e67e22;
  -webkit-box-shadow: inset 0 0 0 1px #e67e22;
  background-color: rgba(230, 126, 34, 0.3);
  color: #e67e22;
}

.manufacture.current {
  background-color: #e67e22;
  color: white;
  font-weight: bold;
}

.installation {
  box-shadow: inset 0 0 0 1px #34495e;
  -moz-box-shadow: inset 0 0 0 1px #34495e;
  -webkit-box-shadow: inset 0 0 0 1px #34495e;
  background-color: rgba(52, 73, 94, 0.3);
  color: #34495e;
}

.installation.current {
  background-color: #34495e;
  color: white;
  font-weight: bold;
}

.done {
  box-shadow: inset 0 0 0 1px #27ae60;
  -moz-box-shadow: inset 0 0 0 1px #27ae60;
  -webkit-box-shadow: inset 0 0 0 1px #27ae60;
  background-color: rgba(39,174,96, 0.3);
  color: #27ae60;
}

.done.current {
  background-color: #27ae60;
  color: white;
  font-weight: bold;
}

@media screen and (max-width: 991px) {
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 48px;
    margin: 0 16px;
    width: calc(100vw - 32px);
  }

  .setting-w {
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 0 16px;
    width: 100%;
    margin-bottom: 80px;
  }

  .offline-warning {
    margin: 0 16px 12px 16px;
    box-sizing: border-box;
    padding: 4px 16px;
    border-radius: 10px;
    width: calc(100vw - 32px);
    font-size: 15px;
    line-height: 30px;
    background-color: rgba(0,0,0,0.12);
  }

  .settings {
    width: calc(100vw - 32px);
    /* margin: 8px 8px; */
    border: solid 1px #f0f0f0;
    border-radius: 15px;
    background-color: #ffffff;
    box-sizing: border-box;
    padding: 20px;
  }
}
</style>
